import React from "react";
import { TabView, TabPanel } from 'primereact/tabview';
import { Roles } from "./adminListing/roles";
import { Users } from "./adminListing/users";
import { getConfiguredLabel } from "../../../common/commonHelper";
import { adminPage, roleTabName, userTabName } from "../../../common/labelConstants";

export const Admin = () => {
    return (
        <div className="upload_documents">
            <div className="slb-container-fluid">
                <TabView>
                    <TabPanel header={getConfiguredLabel(adminPage,userTabName)}>
                        <Users />
                    </TabPanel>
                    <TabPanel header={getConfiguredLabel(adminPage,roleTabName)}>
                        <Roles />
                    </TabPanel>
                    
                </TabView>
            </div>
        </div>
    )
}